<template>
  <div class="z-message"></div>
</template>

<script>
export default {
  name: 'ZMessage'
}
</script>

<style lang="postcss">
.z-message {
  font-size: 14px;
  position: fixed;
  z-index: 1010;
  width: 100%;
  top: 16px;
  left: 0;
  pointer-events: none;
}

.load-loop {
  animation: ani-load-loop 1s linear infinite;
}

@keyframes ani-load-loop {
  0% {
    transform: rotate(0);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(1turn);
  }
}

@keyframes moveUpIn {
  0% {
    transform-origin: 0 0;
    transform: translateY(-100%);
    opacity: 0;
  }

  to {
    transform-origin: 0 0;
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes moveUpOut {
  0% {
    transform-origin: 0 0;
    transform: translateY(0);
    opacity: 1;
  }

  to {
    transform-origin: 0 0;
    transform: translateY(-100%);
    opacity: 0;
  }
}

.move-up-appear,
.move-up-enter-active,
.move-up-leave-active {
  animation-duration: 0.3s;
  animation-fill-mode: both;
  animation-play-state: paused;
}

.move-up-appear,
.move-up-enter-active {
  animation-name: moveUpIn;
  animation-play-state: running;
}

.move-up-leave-active {
  animation-name: moveUpOut;
  animation-play-state: running;
}

.move-up-appear,
.move-up-enter-active {
  opacity: 0;
  animation-timing-function: ease-in-out;
}
</style>
